import { MouseEventHandler } from "react";

export const buttonClassName = (
  selected: string,
  name: string,
  disabled?: boolean
) => {
  if (disabled) {
    return "disabledButtonComponent";
  }
  return selected === name ? "selectedButtonComponent" : "buttonComponent";
};

export interface ButtonComponentProps {
  name: string;
  selected: string;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  isDisabled?: boolean;
}
